import Browser from '@mindful-web/marko-web/browser';
import Shared from '@science-medicine-group/package-global/browser';

Shared(Browser);

export default Browser;
